module.exports = __webpack_public_path__ + "img/LENS_REFLECTIONS.png";